








import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { uri } from "@/config/map/map.config.json";

import L from "leaflet";
import { LMap, LTileLayer, LMarker, LCircle, LPopup } from "vue2-leaflet";
import { Icon } from "leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
type D = Icon.Default & {
  _getIconUrl?: string;
};
delete (Icon.Default.prototype as D)._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
@Component({
  name: "MarkerMap",
  components: {
    "l-map": LMap,
    "l-tile-layer": LTileLayer,
    "l-marker": LMarker,
    "l-circle": LCircle,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
    "l-popup": LPopup,
  },
})
export default class ExcursionMap extends Vue {
  @Prop({ type: Array, default: [] }) dot!: Array<number>;

  circleDots: L.Circle[] = [];

  url = uri;
  attribution =
    '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors';
  zoom = 11;
  center = [55, 37];
  markerLatLng: number[] | null = null;
  radius: number | null = 16;

  map!: L.Map;

  $refs!: {
    map: LMap;
  };

  @Watch("dots")
  updateCenter(): void {
    this.center = this.dot;
  }

  mounted(): void {
    this.$nextTick(() => {
      this.map = this.$refs.map.mapObject;
      this.map.attributionControl.setPrefix("Leaflet");
    });
    this.updateCenter();
  }
}
